import { render, staticRenderFns } from "./SubCategories.vue?vue&type=template&id=222fdd4c&scoped=true&"
import script from "./SubCategories.vue?vue&type=script&lang=js&"
export * from "./SubCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubCategories.vue?vue&type=style&index=0&id=222fdd4c&lang=scss&scoped=true&"
import style1 from "./SubCategories.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./SubCategories.vue?vue&type=style&index=2&id=222fdd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222fdd4c",
  null
  
)

export default component.exports